export const edgeAwareTransform = (pct: number): string =>
	pct > 80
		? "translateX(-100%)"
		: pct < 20
			? "translateX(0)"
			: "translateX(-50%)";
